import { z } from 'zod'

export const Store = z.object({
    id: z.number(),
    name: z.string(),
    owner: z.number(),
    sync_mode: z.string(),
    has_required_merges: z.boolean(),
})
export type Store = z.infer<typeof Store>


export const StoreNote = z.object({
    id: z.number(),
    store: z.number(),
    content: z.string().nullable(),
    title: z.string(),
    media: z.array(z.object({ id: z.number().nullable(), media: z.string().nullable(), description: z.string().nullable()})),
})
export type StoreNote = z.infer<typeof StoreNote>
